export type TabId = 'myProjects' | 'reviewProjects';

export type WorkflowFrontendRole =
  | 'jefe_servicio_OGIA'
  | 'apoyo_OGIA'
  | 'funcional_OGIA'
  | 'juridico_OGIA'
  | 'tecnico_OGIA'
  | 'dpd_OGIA';

export type WorkflowBackendRole = 'JS' | 'RF' | 'RJ' | 'RT' | 'RDPD' | 'GA';

export interface StoredUserData {
  orgCode?: string;
  roleCode?: string;
  roles?: Record<string, string[]>;
}

export interface WorkflowFilter {
  role: WorkflowBackendRole;
  org: string[];
}

export interface DateRangeFilterValue {
  startDate?: string;
  endDate?: string;
}

export interface ProjectsAdvancedFilter {
  org: string[];
  state: string[];
  creationDate: DateRangeFilterValue;
  modificationDate: DateRangeFilterValue;
  procedure: string[];
  application: string[];
  system: string[];
  search: string;
  jobcode?: string;
  serviceManagerOrg?: string[];
  workflow?: WorkflowFilter;
}

export interface ProjectsListParams {
  basicFilter: {
    currentPage: number;
    sizePages: number;
    nameOrderBy: string;
    orderBy: string;
  };
}

export interface ProjectsListAdvancedParams {
  advancedFilter: ProjectsAdvancedFilter;
}

export interface DynamicFilterItem {
  name: string;
}

export type DynamicFiltersResponse = Partial<
  Record<'organismo' | 'procedimiento' | 'aplicacion' | 'sistema', DynamicFilterItem[]>
>;

export const workflowRoleMap: Record<WorkflowFrontendRole, WorkflowBackendRole> = {
  jefe_servicio_OGIA: 'JS',
  funcional_OGIA: 'RF',
  juridico_OGIA: 'RJ',
  tecnico_OGIA: 'RT',
  dpd_OGIA: 'RDPD',
  apoyo_OGIA: 'GA',
};
